import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white py-6">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        {/* Left section - Website creator */}
        <div className="text-center md:text-left mb-4 md:mb-0">
          <p className="text-gray-700">Website created by DZ-Company s.r.o</p>
        </div>

        {/* Center section - Company details */}
        <div className="text-center">
          <p className="text-gray-700 font-bold">Pizza Factory s.r.o.</p>
          <p className="text-gray-700">08323917</p>
          <p className="text-gray-700">Okružní 28/14, 326 00 Plzeň - Božkov</p>
        </div>

        {/* Right section - Contact email */}
        <div className="text-center md:text-right mt-4 md:mt-0">
          <p className="text-gray-700">Email: <a href="mailto:info@pizzapointwest.cz" className="text-blue-500">info@pizzapointwest.cz</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;